<template>
  <div>
    <router-view />
    <cross-domain></cross-domain>
  </div>
</template>

<script>
  import navHeader from "@/components/navigation/navHeader.vue";
  export default {
    name: 'App',
    components: {
      navHeader
    },
    async mounted() {
      if (localStorage.getItem("CTC_REFRESH_TOKEN") || localStorage.getItem("CTC_AUTH_TOKEN")) {
        try {
          await this.$refresh();
          if (this.$store.getters.isLoggedIn) {
            if (!this.$store.getters.isAdmin) {
              if (this.$route.name !== "loginFlow") {
                if (this.$store.getters.user.MustAgreeCTC)
                  this.$router.push("/agree");
                else {
                  this.$router.push("/index");
                }
              }
            }
          }
        }
        catch (err) {
          this.$store.dispatch("logout");
          console.error(err);
        }
      }
    },
    mounted() {

    }
  }
</script>

<style>
</style>
